module.exports = __webpack_public_path__ + "img/specials-multislider-lincoln.7c9f6066.png";